import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "../../../../../shared/modal/modal.component";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: 'app-confirm-wip-action-modal',
  templateUrl: './confirm-wip-action-modal.component.html',
  styleUrl: './confirm-wip-action-modal.component.scss'
})
export class ConfirmWipActionModalComponent {
  @ViewChild('modal') modal: ModalComponent;

  @Output('setOneConfirmed') setOneConfirmed = new EventEmitter();
  @Output('setAllConfirmed') setAllConfirmed = new EventEmitter();
  @Output('unsetOneConfirmed') unsetOneConfirmed = new EventEmitter();
  @Output('unsetAllConfirmed') unsetAllConfirmed = new EventEmitter();

  action: string = 'set';
  form: FormGroup = new FormGroup({
    allExpenses: new FormControl<boolean>(false)
  });

  showConfirmSetWip() {
    this.action = 'set';
    this.modal.show();
    this.form.patchValue({
      allExpenses: false
    });
  }

  showConfirmUnsetWip() {
    this.action = 'unset';
    this.modal.show();
    this.form.patchValue({
      allExpenses: false
    });
  }

  onConfirmed() {
    if (this.form.get('allExpenses').value === true) {
      switch (this.action) {
        case 'unset':
          this.unsetAllConfirmed.emit();
          break;
        default:
          this.setAllConfirmed.emit();
          break;
      }
    } else {
      switch (this.action) {
        case 'unset':
          this.unsetOneConfirmed.emit();
          break;
        default:
          this.setOneConfirmed.emit();
          break;
      }
    }

    this.hide();
  }

  onNotConfirmed() {
    this.hide();
  }

  hide() {
    this.modal.hide();
  }

}
